<template>
  <dev>
    <p v-if="isLoading">Загрузка...</p>
    <b-table-simple v-else bordered="">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>#</b-th>
          <b-th>Учетный месяц</b-th>
          <b-th>Учетный год</b-th>
          <b-th>Сумма начисление</b-th>
          <b-th>БИН ДО</b-th>
          <b-th>LMS ID</b-th>
          <b-th>Документ</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(data, index) in childFactPaymentResponseList" :key="index">
          <b-tr>
            <b-td>{{ index + 1 }}</b-td>
            <b-td>{{ data.accountingMonth }}</b-td>
            <b-td>{{ data.accountingYear }}</b-td>
            <b-td>{{ data.payedAmount }}</b-td>
            <b-td>{{ data.bin }}</b-td>
            <b-td>{{ data.lmsId }}</b-td>
            <b-td>
              <a
                  @click="handleDownload(data.reportUUID, data.signedPdfName)"
                  class="active-link"
              >
                {{ data.signedPdfName }}
              </a>
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </dev>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {getChildrenFactPayments} from "@/services/childrenService";
import {ChildFactPaymentResponse} from "@/types/childrenResponse";
import {downloadReportFile} from "@/services/reportService";

export default defineComponent({
  name: 'ChildrenPaymentView',
  setup() {
    const childId = ref<string>("");
    const isLoading = ref(false);
    const childFactPaymentResponseList = ref<ChildFactPaymentResponse[]>([]);

    const fetchData = async () => {
      isLoading.value = true;
      try {
        childFactPaymentResponseList.value = await getChildrenFactPayments(childId.value);
      } catch (error) {
        console.error("Error fetching child short info list:", error);
      }
      isLoading.value = false;
    }

    const handleDownload = async (fileId: string, fileName: string) => {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          await downloadReportFile(token, fileId, fileName);
        }
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    };

    onMounted(() => {
      const route = useRoute();
      childId.value = route.params.id as string;
      fetchData();
    });

    return {
      isLoading,
      childFactPaymentResponseList,
      handleDownload,
    }
  }
})
</script>

<style scoped></style>